export default __webpack_public_path__ + "static/media/Cloak of Equivalence.8cc035ce.jpg";